'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var Vue = _interopDefault(require('vue'));

var formatKey = function (str) {
  var pattern = /\{(.*)\}/;
  var ref = str.match(pattern) || [];
  var specialChar = ref[1];
  return {
    value: specialChar || str,
    type: specialChar ? 'action' : 'input'
  };
};

var formatRow = function (str, iterator) {
  var trimed = str.split(/\s+/);
  return trimed.map(iterator);
};

var translateText = function (keyId, locale) {
  if ( locale === void 0 ) locale = '';

  var ref = locale.split(':');
  var translation = ref[0];
  return translation || keyId;
};

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) { continue; } if (!Object.prototype.hasOwnProperty.call(obj, i)) { continue; } target[i] = obj[i]; } return target; }

var defaultLayout = 'msUSEnglish';

var Keyboard = { render: function () {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { staticClass: "v-keyboard", class: [_vm.classnames.wrapper, ("theme-" + (_vm.theme))] }, [_vm.rowsToDisplay ? _vm._l(_vm.rowsToDisplay, function (row) {
      return _c('div', { staticClass: "row", class: _vm.classnames.row }, _vm._l(row, function (key, i) {
        return _c('button', { key: i, staticClass: "keybtn", class: [_vm.classnames.key, ("key-" + (key.type) + "-" + (key.value)), key.value === _vm.internalTypeset && key.type === 'action' ? '-active' : ''], attrs: { "type": "button" }, on: { "click": function ($event) {
              _vm.onKeyPress(key);
            } } }, [_c('slot-renderer', { attrs: { "vnode": _vm.$scopedSlots[((key.type) + ":" + (key.value))] && _vm.$scopedSlots[((key.type) + ":" + (key.value))]({ args: key }) } }, [_vm._v(" " + _vm._s(key.translation) + " ")])], 1);
      }));
    }) : _vm._e()], 2);
  }, staticRenderFns: [],
  name: 'Keyboard',
  props: {
    lang: {
      type: String
    },
    layout: {
      type: String
    },
    defaultLayout: {
      type: String,
      default: defaultLayout
    },
    typeset: {
      type: String,
      default: 'normal'
    },
    theme: {
      type: String,
      default: 'default'
    },
    classnames: {
      type: Object,
      default: function () { return ({
        wrapper: 'wrapper-class',
        row: 'row-class',
        key: 'key-class'
      }); }
    }
  },
  methods: {
    onKeyPress: function onKeyPress(value) {
      this.$emit('trigger', value);
      this.defaultActions(value);
    },
    defaultActions: function defaultActions(ref) {
      var type = ref.type;
      var value = ref.value;

      if (type === 'action') {
        //toggle typeset
        var _currentLayout = this.currentLayout;
        var name = _currentLayout.name;
        var lang = _currentLayout.lang;
        var typesets = _objectWithoutProperties(_currentLayout, ['name', 'lang']);

        if (typesets.hasOwnProperty(value)) {
          this.internalTypeset = this.internalTypeset === value ? 'normal' : value;
        }
      }
    }
  },
  data: function () { return ({
    internalTypeset: null
  }); },
  watch: {
    typeset: {
      immediate: true,
      handler: function handler(typeset) {
        this.internalTypeset = typeset;
      }
    }
  },
  inject: {
    injectedLocales: {
      from: '_vkeyboard_locales'
      // default: () => ({})
    },
    injectedLayouts: {
      from: '_vkeyboard_layouts'
      // default: () => ({})
    }
  },
  computed: {
    availableLocales: function availableLocales() {
      return this.injectedLocales;
    },
    availableLayouts: function availableLayouts() {
      return this.injectedLayouts;
    },
    currentLayout: function currentLayout() {
      if (!this.availableLayouts) {
        Vue.util.warn("no layouts provided");
        return;
      }
      var hasLayout = this.layout && this.layout in this.availableLayouts;
      if (!hasLayout) {
        Vue.util.warn(("no layout matching provided: falling back to the default: " + (this.defaultLayout)));
      }
      var layout = hasLayout ? this.layout : this.defaultLayout;
      return this.availableLayouts[layout];
    },
    currentLang: function currentLang() {
      if (!this.currentLayout) { return; }
      var hasLang = this.lang && this.currentLayout.lang.includes(this.lang);
      var lang = hasLang ? this.lang : this.currentLayout.lang[0];
      if (!hasLang) {
        Vue.util.warn(("no locale matching lang provided: falling back to " + lang));
      }
      return lang;
    },
    rowsToDisplay: function rowsToDisplay() {
      if (!this.currentLayout) { return []; }
      var locale = this.availableLocales[this.currentLang];
      var typeset = this.internalTypeset;
      if (!([typeset] in this.currentLayout)) {
        Vue.util.warn(("undefined typeset: " + typeset));
        typeset = 'normal';
      }
      var rows = this.currentLayout[typeset].map(function (str) {
        return formatRow(str, function (key) {
          var ref = formatKey(key);
          var type = ref.type;
          var value = ref.value;
          return {
            type: type,
            value: value,
            translation: type === 'action' ? translateText(value, locale && locale.display[value]) : value
          };
        });
      });
      return rows;
    }
  },
  components: {
    slotRenderer: {
      functional: true,
      props: {
        vnode: { required: true },
        args: {}
      },
      render: function render(h, ref) {
        var parent = ref.parent;
        var props = ref.props;
        var children = ref.children;

        return props.vnode || children;
      }
    }
  }
};

/* US English (Latin) Keyboard Layout
 * generated from http://www.microsoft.com/resources/msdn/goglobal/keyboards/kbdus.html
 */
var msUSEnglish = {
	"name": "ms-US English (Latin)",
	"lang": ["en"],
	"normal": ["` 1 2 3 4 5 6 7 8 9 0 - = {bksp}", "{tab} q w e r t y u i o p [ ] \u005c", "a s d f g h j k l ; ' {enter}", "{shift} \u005c z x c v b n m , . / {shift}", "{accept} {space} {cancel}"],
	"shift": ["~ ! @ # $ % ^ & * ( ) _ + {bksp}", "{tab} Q W E R T Y U I O P { } |", "A S D F G H J K L : \u0022 {enter}", "{shift} | Z X C V B N M < > / {shift}", "{accept} {space} {cancel}"]
};

/* US English (IBM Arabic 238_L) Keyboard Layout
 * generated from http://www.microsoft.com/resources/msdn/goglobal/keyboards/kbdusa.html
 */


/* US-International Keyboard Layout
 * generated from http://www.microsoft.com/resources/msdn/goglobal/keyboards/kbdusx.html
 */

/* Spanish keyboard layouts
 * contains layouts: 'spanish-qwerty' and 'spanish-qwerty-sp'
 *
 * To use:
 *  Point to this js file into your page header: <script src="layouts/spanish.js" type="text/javascript"></script>
 *  Initialize the keyboard using: $('input').keyboard({ layout: 'spanish-qwerty' });
 *
 * license for this file: WTFPL, unless the source layout site has a problem with me using them as a reference
 *
 * Spanish layouts by Paco Alcantara (https://github.com/pacoalcantara)
 * Based on: http://ascii-table.com/keyboard.php/171 and http://ascii-table.com/keyboard.php/071-2
 */
var spanish = {
	'name': 'spanish-qwerty',
	'lang': ['es'],
	'normal': ["\u007c 1 2 3 4 5 6 7 8 9 0 \' \u00bf {bksp}", "{tab} q w e r t y u i o p \u0301 +", "a s d f g h j k l \u00f1 \u007b \u007d {enter}", "{shift} < z x c v b n m , . - {shift}", "{accept} {alt} {space} {alt} {cancel}"],
	'shift': ["\u00b0 ! \" # $ % & / ( ) = ? \u00a1 {bksp}", "{tab} Q W E R T Y U I O P \u0308 *", "A S D F G H J K L \u00d1 \u005b \u005d {enter}", "{shift} > Z X C V B N M ; : _ {shift}", "{accept} {alt} {space} {alt} {cancel}"],
	'alt': ["\u00ac 1 2 3 4 5 6 7 8 9 0 \\ \u00bf {bksp}", "{tab} @ w e r t y u i o p \u0301 \u0303", "a s d f g h j k l \u00f1 \u0302 \u0300 {enter}", "{shift} < z x c v b n m , . - {shift}", "{accept} {alt} {space} {alt} {cancel}"],
	'alt-shift': ["\u00b0 ! \" # $ % & / ( ) = ? \u00a1 {bksp}", "{tab} Q W E R T Y U I O P \u0308 *", "A S D F G H J K L \u00d1 \u005b \u005d {enter}", "{shift} > Z X C V B N M ; : _ {shift}", "{accept} {alt} {space} {alt} {cancel}"]
};

/* Polish keyboard layouts
 * contains layout: 'polish-qwerty'
 * Author: Piotr Roznicki
 *
 * To use:
 *  Point to this js file into your page header: <script src="layouts/polish.js" type="text/javascript"></script>
 *  Initialize the keyboard using: $('input').keyboard({ layout: 'polish-qwerty' });
 *
 * license for this file: WTFPL, unless the source layout site has a problem with me using them as a reference
 */

var polish = {
	'name': 'polish-qwerty',
	'lang': ['pl'],
	'normal': ["` 1 2 3 4 5 6 7 8 9 0 - = {bksp}", "{tab} q w e r t y u i o p [ ] \u00B0", "a s d f g h j k l ; ' {enter}", "{shift} z x c v b n m , . / {shift}", "{accept} {alt} {space} {alt} {cancel}"],
	'shift': ['~ ! @ # $ % ^ & * ( ) _ + {bksp}', "{tab} Q W E R T Y U I O P { } |", 'A S D F G H J K L : " {enter}', "{shift} Z X C V B N M < > ? {shift}", "{accept} {alt} {space} {alt} {cancel}"],
	'alt': ["` 1 2 3 4 5 6 7 8 9 0 - = {bksp}", "{tab} q w \u0119 r t y \u20ac i \u00f3 p [ ] \u00B0", '\u0105 \u015b d f g h j k \u0142 : " {enter}', "{shift} \u017c \u017a \u0107 v b \u0144 m , . / {shift}", "{accept} {alt} {space} {alt} {cancel}"]
};

/* Portuguese (pt) keyboard layout
 * contains layout: 'portuguese-qwerty'
 *
 * To use:
 *  Point to this js file into your page header: <script src="layouts/portuguese-pt.js" type="text/javascript"></script>
 *  Initialize the keyboard using: $('input').keyboard({ layout: 'portuguese-pt' });
 *
 * license for this file: WTFPL, unless the source layout site has a problem with me using them as a reference

 * Portuguese-pt layout by Luiz Castelo-Branco ( translations at Castelo-Branco . org ), based on:
 * http://ascii-table.com/keyboard.php/163 and/with
 * Unicode 6.2 from http://www.unicode.org/Public/6.2.0/charts/CodeCharts.pdf

*/

// portuguese-pt
var portuguese = {
	'name': 'portuguese-qwerty',
	'lang': ['pt'],
	'normal': ["\u005C 1 2 3 4 5 6 7 8 9 0 \u0027 \u00ab {bksp}", "{tab} q w e r t y u i o p \u002b \u00b4", "a s d f g h j k l \u00e7 \u00ba \u007e {enter}", "{shift} \u003c z x c v b n m \u002c \u002e \u002d {shift}", "{cancel} {space} {alt} {combo} {accept}"],
	'shift': ["\u007c \u0021 \u0022 \u0023 \u0024 \u0025 \u0026 \u002f \u0028 \u0029 \u003d \u003F \u00bb {bksp}", "{tab} Q W E R T Y U I O P \u002a \u0060", "A S D F G H J K L \u00c7 \u00aa \u005e {enter}", "{shift} \u003e Z X C V B N M \u003b \u003a \u005f {shift}", "{cancel} {space} {alt} {combo} {accept}"],
	// AltGr
	'alt': ["\u005C 1 \u0040 \u00a3 \u00a7 \u20ac 6 \u007b \u005b \u005d \u007d \u0027 \u00ab {bksp}", "{tab} q w \u20ac r t y u i o p \u0308 \u00b4", "a s d f g h j k l \u00e7 \u00ba \u007e {enter}", "{shift} \u003c z x c v b n m \u002c \u002e \u002d {shift}", "{cancel} {space} {alt} {combo} {accept}"],
	'alt-shift': ["\u007c \u0021 \u0022 \u0023 \u0024 \u0025 \u0026 \u002f \u0028 \u0029 \u003d \u003F \u00bb {bksp}", "{tab} Q W \u20ac R T Y U I O P \u0308 \u0060", "A S D F G H J K L \u00c7 \u00aa \u005e {enter}", "{shift} \u003e Z X C V B N M \u003b \u003a \u005f {shift}", "{cancel} {space} {alt} {combo} {accept}"]

};

/* German keyboard layouts
 * contains layout: 'german-qwertz-1' & 'german-qwertz-2'
 *
 * To use:
 *  Point to this js file into your page header: <script src="layouts/german.js" type="text/javascript"></script>
 *  Initialize the keyboard using: $('input').keyboard({ layout: 'german-qwertz-1' });
 *
 * license for this file: WTFPL, unless the source layout site has a problem with me using them as a reference
 */

/* from http://ascii-table.com/keyboard.php/129 */
var german = {
	'name': 'german-qwertz-1',
	'lang': ['de'],
	'normal': ["\u0302 1 2 3 4 5 6 7 8 9 0 \u00df \u0301 {bksp}", "{tab} q w e r t z u i o p \u00fc +", "a s d f g h j k l \u00f6 \u00e4 # {enter}", "{shift} < y x c v b n m , . - {shift}", "{accept} {alt} {space} {alt} {cancel}"],
	'shift': ['\u00b0 ! " \u00a7 $ % & / ( ) = ? \u0300 {bksp}', "{tab} Q W E R T Z U I O P \u00dc *", "A S D F G H J K L \u00d6 \u00c4 ' {enter}", "{shift} > Y X C V B N M ; : _ {shift}", "{accept} {alt} {space} {alt} {cancel}"],
	'alt': ['\u0302 1 \u00b2 \u00b3 4 5 6 { [ ] } \\ \u0301 {bksp}', "{tab} @ w \u20ac r t z u i o p \u00fc \u0303", "a s d f g h j k l \u00f6 \u00e4 # {enter}", "{shift} \u007c y x c v b n \u00b5 , . - {shift}", "{accept} {alt} {space} {alt} {cancel}"]
};

/* from http://ascii-table.com/keyboard.php/150G-1 */

/* French keyboard layouts
 * contains layout: french-azerty-1 and 'french-azerty-2'
 *
 * To use:
 *  Point to this js file into your page header: <script src="layouts/french.js" type="text/javascript"></script>
 *  Initialize the keyboard using: $('input').keyboard({ layout: 'french-azerty-1' });
 *
 * license for this file: WTFPL, unless the source layout site has a problem with me using them as a reference
 */

/* based on http://ascii-table.com/keyboard.php/189 & thanks to Nathana�l SEMHOUN: http://nathanael.semhoun.net */
var french = {
	'name': 'french-azerty-1',
	'lang': ['fr'],
	'normal': ["\u00b2 & \u00e9 \" ' ( - \u00e8 _ \u00e7 \u00e0 ) = {bksp}", "{tab} a z e r t y u i o p ^ $", "q s d f g h j k l m  \u00f9 * {enter}", "{shift} < w x c v b n , ; : ! {shift}", "{accept} {alt} {space} {alt} {cancel}"],
	'shift': ["{sp:1} 1 2 3 4 5 6 7 8 9 0 \u00b0 + {bksp}", "{tab} A Z E R T Y U I O P \u00a8 \u00a3", "Q S D F G H J K L M % \u00b5 {enter}", "{shift} > W X C V B N ? . / \u00a7 {shift}", "{accept} {alt} {space} {alt} {cancel}"],
	'alt': ["\u00b2 & ~ # { [ | ` \\ ^ @ ] } {bksp}", "{tab} a z \u20ac r t y u i o p ^ \u00a4", "q s d f g h j k l m  \u00f9 * {enter}", "{shift} < w x c v b n , ; : ! {shift}", "{accept} {alt} {space} {alt} {cancel}"],
	'alt-shift': ["{sp:1} 1 ~ # { [ | ` \\ ^ @ ] } {bksp}", "{tab} A Z \u20ac R T Y U I O P \u00a8 \u00a4", "Q S D F G H J K L M % \u00b5 {enter}", "{shift} > W X C V B N ? . / \u00a7 {shift}", "{accept} {alt} {space} {alt} {cancel}"]
};



var layouts = Object.freeze({
	msUSEnglish: msUSEnglish,
	spanish: spanish,
	polish: polish,
	portuguese: portuguese,
	german: german,
	french: french
});

// Keyboard Language
// please update this section to match this language and email me with corrections!
// fr = ISO 639-1 code for French
// ***********************
var fr = {
	language: 'Fran\u00e7ais (French)',
	display: {
		'a': '\u2714:Valider (Shift+Enter)', // check mark - same action as accept
		'accept': 'Valider:Valider (Shift+Enter)',
		'alt': 'AltGr:Charact\u00e8re alternatif',
		'b': '\u2190:Suppr arri\u00e8re', // Left arrow (same as &larr;)
		'bksp': '\u2190Suppr:Suppr arri\u00e8re',
		'c': '\u2716:Annuler', // big X, close - same action as cancel
		'cancel': 'Annuler:Annuler (\u00c9chap)',
		'clear': 'C:Effacer', // clear num pad
		'combo': '\u00f6:Bacsuler les touches combo',
		'dec': '.:Decimal', // decimal point for num pad (optional), change '.' to ',' for European format
		'e': '\u21b5:Entr\u00e9e', // down, then left arrow - enter symbol
		'enter': 'Entr\u00e9e:Entr\u00e9e',
		'lock': '\u21ea Verr Mag:Verouillage majuscule', // caps lock
		's': '\u21e7:Majuscule', // thick hollow up arrow
		'shift': 'Maj:Majuscule',
		'sign': '\u00b1:Change de signe', // +/- sign for num pad
		'space': '\u00A0:Espace',
		't': '\u21e5:Tabulation', // right arrow to bar (used since this virtual keyboard works with one directional tabs)
		'tab': '\u21e5 Tab:Tabulation' // \u21b9 is the true tab symbol (left & right arrows)
	},
	// Message added to the key title while hovering, if the mousewheel plugin exists
	wheelMessage: 'Utiliser la molette de la souris pour voir les autres lettres'
};

// Keyboard Language
// please update this section to match this language and email me with corrections!
// "all" is used here for example purposes, by convention it should be the ISO 639-1 code for the specified language
// ***********************
var en = {
		language: 'All (English translation)', // e.g. 'Русский (Russian)'
		display: {
				'a': '\u2714:Accept (Shift+Enter)', // check mark - same action as accept
				'accept': 'Accept:Accept (Shift+Enter)',
				'alt': 'AltGr:Alternate Graphemes',
				'b': '\u2190:Backspace', // Left arrow (same as &larr;)
				'bksp': 'Bksp:Backspace',
				'c': '\u2716:Cancel (Esc)', // big X, close - same action as cancel
				'cancel': 'Cancel:Cancel (Esc)',
				'clear': 'C:Clear', // clear num pad
				'combo': '\u00f6:Toggle Combo Keys',
				'dec': '.:Decimal', // decimal point for num pad (optional), change '.' to ',' for European format
				'e': '\u21b5:Enter', // down, then left arrow - enter symbol
				'enter': 'Enter:Enter',
				'lock': '\u21ea Lock:Caps Lock', // caps lock
				's': '\u21e7:Shift', // thick hollow up arrow
				'shift': 'Shift:Shift',
				'sign': '\u00b1:Change Sign', // +/- sign for num pad
				'space': '\u00A0:Space',
				't': '\u21e5:Tab', // right arrow to bar (used since this virtual keyboard works with one directional tabs)
				'tab': '\u21e5 Tab:Tab' // \u21b9 is the true tab symbol (left & right arrows)
		},
		// Message added to the key title while hovering, if the mousewheel plugin exists
		wheelMessage: 'Use mousewheel to see other keys'

		// uncomment, then include changes to the comboRegex here
		/*
  , comboRegex : /([`\'~\^\"ao])([a-z])/mig,
  */

		// uncomment, then include any changes to the combos option here
		/*
  , combos : {
  	// grave
  	'`' : { a:"\u00e0", A:"\u00c0", e:"\u00e8", E:"\u00c8", i:"\u00ec", I:"\u00cc", o:"\u00f2", O:"\u00d2",
  			u:"\u00f9", U:"\u00d9", y:"\u1ef3", Y:"\u1ef2" },
  	// acute & cedilla
  	"'" : { a:"\u00e1", A:"\u00c1", e:"\u00e9", E:"\u00c9", i:"\u00ed", I:"\u00cd", o:"\u00f3", O:"\u00d3",
  			u:"\u00fa", U:"\u00da", y:"\u00fd", Y:"\u00dd" },
  	// umlaut/trema
  	'"' : { a:"\u00e4", A:"\u00c4", e:"\u00eb", E:"\u00cb", i:"\u00ef", I:"\u00cf", o:"\u00f6", O:"\u00d6",
  			u:"\u00fc", U:"\u00dc", y:"\u00ff", Y:"\u0178" },
  	// circumflex
  	'^' : { a:"\u00e2", A:"\u00c2", e:"\u00ea", E:"\u00ca", i:"\u00ee", I:"\u00ce", o:"\u00f4", O:"\u00d4",
  			u:"\u00fb", U:"\u00db", y:"\u0177", Y:"\u0176" },
  	// tilde
  	'~' : { a:"\u00e3", A:"\u00c3", e:"\u1ebd", E:"\u1ebc", i:"\u0129", I:"\u0128", o:"\u00f5", O:"\u00d5",
  			u:"\u0169", U:"\u0168", y:"\u1ef9", Y:"\u1ef8", n:"\u00f1", N:"\u00d1" }
  },
  // language direction
  rtl : false
  */
};

// Keyboard Language
// please update this section to match this language and email me with corrections!
// es = ISO 639-1 code for Spanish
// ***********************
var es = {
	language: 'Espa\u00f1ol (Spanish)',
	display: {
		'a': '\u2714:Acceptar (Cambio+Inscribir)', // check mark - same action as accept
		'accept': 'Acceptar:Acceptar (Cambio+Inscribir)',
		'alt': 'AltGr:Grafemas Alternativos',
		'b': '\u2190:Retroceso', // Left arrow (same as &larr;)
		'bksp': 'Bksp:Retroceso',
		'c': '\u2716:Cancelar (Esc)', // big X, close - same action as cancel
		'cancel': 'Cancelar:Cancelar (Esc)',
		'clear': 'C:Vaciar', // clear num pad
		'combo': '\u00f6:Alternar las Teclas Combinados',
		'dec': ',:Decimal', // decimal point for num pad (optional), change '.' to ',' for European format
		'e': '\u21b5:Inscribir', // down, then left arrow - enter symbol
		'enter': 'Inscribir:Inscribir',
		'lock': '\u21ea Bloq:Mayús', // caps lock
		's': '\u21e7:Cambio', // thick hollow up arrow
		'shift': 'Cambio:Cambio',
		'sign': '\u00b1:Cambiar Signo', // +/- sign for num pad
		'space': '\u00A0:Espacio',
		't': '\u21e5:Tab', // right arrow to bar (used since this virtual keyboard works with one directional tabs)
		'tab': '\u21e5 Tab:Tab' // \u21b9 is the true tab symbol (left & right arrows)
	},
	wheelMessage: 'Utilice la rueda del mouse para ver otras teclas'
};

// Keyboard Language
// please update this section to match this language and email me with corrections!
// de = ISO 639-1 code for German
// ***********************
var de = {
	language: 'Deutsch (German)',
	display: {
		'a': '\u2714:\u00dcbernehmen (Umschalt+Enter)', // check mark - same action as accept
		'accept': '\u00dcbernehmen:\u00dcbernehmen (Umschalt+Enter)',
		'alt': 'AltGr:Alt Graph',
		'b': '\u2190:R\u00fccktaste', // Left arrow (same as &larr;)
		'bksp': 'R\u00fcck:R\u00fccktaste',
		'c': '\u2716:Abbrechen (Esc)', // big X, close - same action as cancel
		'cancel': 'Abbrechen:Abbrechen (Esc)',
		'clear': 'C:L\u00f6schen', // clear num pad
		'combo': '\u00f6:Tottasten umschalten',
		'dec': ',:Dezimal', // decimal point for num pad (optional), change '.' to ',' for European format
		'e': '\u21b5:Eingabe', // down, then left arrow - enter symbol
		'enter': 'Enter:Eingabe',
		'lock': '\u21E9:Feststelltaste', // caps lock
		's': '\u21e7:Umschalttaste', // thick hollow up arrow
		'shift': 'Umschalt:Umschalttaste',
		'sign': '\u00b1:Vorzeichen wechseln', // +/- sign for num pad
		'space': '\u00A0:Leertaste',
		't': '\u21e5:Tabulatortaste', // right arrow to bar (used since this virtual keyboard works with one directional tabs)
		'tab': '\u21e5 Tab:Tabulatortaste' // \u21b9 is the true tab symbol (left & right arrows)
	},
	// Message added to the key title while hovering, if the mousewheel plugin exists
	wheelMessage: 'Mausrad benutzen, um weitere Tasten zu sehen'
};

// Keyboard Language
// please update this section to match this language and email me with corrections!
// pt = ISO 639-1 code for Portuguese
// ***********************
var pt = {
	language: 'Portugu\u00eas (Portuguese)',
	display: {
		'a': '\u2714:Aceitar (Shift+Enter)', // ALTERNATE accept button - unicode for check mark symbol
		'accept': 'Aceitar:Concluir (Shift+Enter)', // Accept button text
		'alt': 'AltGr:Carateres Adicionais/CTRL+ALT', // Alt button text (AltGr is for international key sets)
		'b': '\u2190:Retroceder', // ALTERNATE backspace button - unicode for left arrow. Same as ← ( &larr; ) - Left arrow
		'bksp': '\u2190 Bksp:Retroceder', // Backspace button text
		'c': '\u2716:Cancelar/Escape (Esc)', // ALTERNATE cancel button - unicode for big X
		'cancel': 'Cancel:Cancelar/Escape(Esc)', // Cancel button text
		'clear': 'C:Limpar', // Clear window content (used in num pad)
		'combo': '\u00f6:Acentuação Automática', // (Toggle combo (diacritic) key
		'dec': '.:Decimal', // Decimal point for num pad (optional), change '.' to ',' for European format
		'e': '\u21b5:Introduzir/Mudar de Linha', // ALTERNATE enter button - unicode for down, then left arrow (enter symbol)
		'enter': 'Enter\u21b5:Introduzir/Mudar de Linha', // Enter button text
		'lock': '\u21ea Lock:CapsLock/Maiúsculas', // Caps lock button - unicode for double lined up arrow
		's': '\u21e7:Shift/Maiúsculas', // ALTERNATE shift button - unicode for a thick up arrow
		'shift': '\u21ea Shift:Maiúsculas-Minúsculas', // Shift button text
		'sign': '\u00b1:Mudar Sinal', // Change sign (used in num pad) - unicode for a +- symbol
		'space': '\u00A0:Espaço', // Space button text
		't': '\u21e5:Tab/Tabela/Avançar', // ALTERNATE tab button - unicode for right arrow to bar (used since only one directional tabs available)
		'tab': '\u21e5 Tab:Tabela/Avançar' // Tab button text (Note: \u21b9 is the true tab symbol (left & right arrows) but not used here)
	},
	wheelMessage: 'Use a roda do rato/navegador para ver mais teclas',

	// Update regex for the combos above
	comboRegex: /([`\'~\^\"ao\u00b4])([a-z])/mig,
	// New combos using specific accents
	combos: {
		"\u00b4": { a: "\u00e1", A: "\u00c1", e: "\u00e9", E: "\u00c9", i: "\u00ed", I: "\u00cd", o: "\u00f3", O: "\u00d3", u: "\u00fa", U: "\u00da", y: "\u00fd", Y: "\u00dd" }, // acute & cedilla
		// remove apostrophe combo
		"'": {}
	}

};

// Keyboard Language
// please update this section to match this language and email me with corrections!
// pl = ISO 639-1 code for Polish
// ***********************
var pl = {
	language: 'Polski (Polish)',
	display: {
		'a': '\u2714:Akceptuj (Shift+Enter)', // check mark - same action as accept
		'accept': 'Accept:Akceptuj (Shift+Enter)',
		'alt': 'AltGr:Polskie znaki',
		'b': '\u2190:Cofnij', // Left arrow (same as &larr;)
		'bksp': 'Bksp:Cofnij',
		'c': '\u2716:Anuluj (Esc)', // big X, close - same action as cancel
		'cancel': 'Cancel:Anuluj (Esc)',
		'clear': 'C:Czyść', // clear num pad
		'combo': '\u00f6:Klawisze kombo',
		'dec': '.:Dziesiętny', // decimal point for num pad (optional), change '.' to ',' for European format
		'e': '\u21b5:Enter', // down, then left arrow - enter symbol
		'enter': 'Enter:Enter',
		'lock': '\u21ea Lock:Caps Lock', // caps lock
		's': '\u21e7:Shift', // thick hollow up arrow
		'shift': 'Shift:Shift',
		'sign': '\u00b1:Zmień znak', // +/- sign for num pad
		'space': '\u00A0:Spacja',
		't': '\u21e5:Tab', // right arrow to bar (used since this virtual keyboard works with one directional tabs)
		'tab': '\u21e5 Tab:Tab' // \u21b9 is the true tab symbol (left & right arrows)
	},
	// Message added to the key title while hovering, if the mousewheel plugin exists
	wheelMessage: 'Użyj rolki aby zobaczyć pozozstałe klawisze'
};



var locales = Object.freeze({
	fr: fr,
	en: en,
	es: es,
	de: de,
	pt: pt,
	pl: pl
});

var KeyboardProvider = {
  name: 'KeyboardProvider',
  props: {
    locales: {
      default: function default$1() {
        return locales;
      },
      type: Object
    },
    layouts: {
      default: function default$2() {
        return layouts;
      },
      type: Object
    }
  },
  provide: function provide() {
    var this$1 = this;

    var provide = {};
    Object.defineProperty(provide, '_vkeyboard_locales', {
      get: function () { return this$1.locales; },
      enumerable: true
    });
    Object.defineProperty(provide, '_vkeyboard_layouts', {
      get: function () { return this$1.layouts; },
      enumerable: true
    });
    return provide;
  },
  render: function render(h) {
    return h('div', this.$slots.default);
  }
};

var plugin = function (Vue$$1, ref) {
  if ( ref === void 0 ) ref = {};
  var layouts = ref.layouts;
  var locales = ref.locales;

  var KeyboardWithProvider = {
    name: 'KeyboardWithProvider',
    functional: true,
    render: function (h, ref) {
      var parent = ref.parent;
      var data = ref.data;
      var slots = ref.slots;
      var children = ref.children;

      return h(KeyboardProvider, {
        props: {
          layouts: layouts,
          locales: locales
        }
      }, [parent.$createElement(Keyboard, data, children)]);
    } //HACK use the parent rendering context to support named slots (see: https://github.com/vuejs/vue/issues/5759)
  };
  Vue$$1.component(KeyboardWithProvider.name, KeyboardWithProvider);
};

module.exports = plugin;
